<template>
  <div>
    <table-control
      :items="items"
      :model="model"
      @pagination="reload"
      @click:row="navigate"
      :total="total"
    />
    <v-btn
      color="primary"
      dark
      bottom
      right
      fixed
      fab
      @click="$router.push({ path: '/model/' + $route.params.model + '/new' })"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import TableControl from "../../components/Table";
import _ from "lodash";

export default {
  name: "List",
  data: () => ({}),
  components: {
    TableControl
  },
  computed: {
    items: function() {
      return this.$store.getters["list" + this.modelName];
    },
    model: function() {
      return this.$store.getters["model" + this.modelName];
    },
    modelName: function() {
      let name = this.$route.params.model;
      return name.charAt(0).toUpperCase() + name.substring(1);
    },
    total: function() {
      return this.$store.getters["total" + this.modelName];
    },
    search: function() {
      return this.$store.getters.searchstring.toLowerCase();
    },
    where: function() {
      let search = this.search;
      let res = {
        search: {
          contains: search
        }
      };

      return search.length > 1 ? res : {};
    }
  },
  watch: {
    search(newValue) {
      console.log(newValue);
      this.reload({
        itemsPerPage: 30,
        page: 1,
        sortBy: ["name"]
      })
    }
  },
  mounted() {
    this.$store.dispatch("loadModel" + this.modelName);
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("loadModel" + _.startCase(to.params.model));
    this.$store.dispatch("find" + _.startCase(to.params.model));
    next();
  },
  methods: {
    reload(options) {
      this.$store.dispatch("find" + this.modelName, {
        limit: options.itemsPerPage,
        skip: (options.page - 1) * options.itemsPerPage,
        sort: options.sortBy[0],
        where: this.where
      });
    },
    navigate(row) {
      this.$router.push({
        path: `/model/${this.$route.params.model}/${row.id}`
      });
    }
  }
};
</script>
